import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import axios from "axios";

const About = () => {
  const { t, i18n } = useTranslation();
  const currentLanguage = i18n.language;

  const [settings, setSettings] = useState([]);

  useEffect(() => {
    getQhse();
  }, []);

  async function getQhse() {
    try {
      // API'den verileri çekiyoruz
      const response = await axios.get(
        "https://www.caspianrocksolutions.com/caspianrocksolutions/about.php"
      );
      setSettings(response.data.data[0]); // Gelen veriyi state'e kaydediyoruz
      console.log(response.data);
    } catch (error) {
      console.error("Error fetching categories:", error); // Hata durumunda mesaj yazdırıyoruz
    }
  }

  return (
    <div className="bg-[#EDEDED] pt-10 md:pt-20">
      <div className="max-w-containerSm md:max-w-container mx-auto flex flex-col-reverse md:flex-row justify-between">
        <div className="md:w-[634px] flex flex-col justify-center mt-6 md:mt-0">
          <div>
            <p className="text-[#B31F11] text-[14px] font-medium">ABOUT US</p>
            <p className="text-[28px] md:text-[44px] font-bold text-[#141615] font-firstFont">
              {settings.title}
            </p>
            <p className="mt-5 text-[14px] md:text-[20px] text-[#41444B]">
              {settings.contentShort}
            </p>
            <div className="mt-5">
              <a
                href={`https://www.caspianrocksolutions.com/caspianrocksolutions/${settings.presentation}`}
                target="_blank"
                rel="noopener noreferrer"
                className="inline-flex items-center gap-2 text-[#B31F11] border border-[#B31F11] py-2 px-4 rounded-md hover:bg-[#B31F11] hover:text-white transition-colors"
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  className="h-5 w-5"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d="M12 4v16m8-8H4"
                  />
                </svg>
                {t("CRS Presentation")}
              </a>
            </div>

            <a href={`/${currentLanguage}/about`}>
              <button className="bg-[#B31F11] text-white md:w-[150px] w-full h-[44px] mt-10 rounded hover:bg-[#9a1b0f] transition-colors">
                Learn More
              </button>
            </a>
          </div>
        </div>
        <div className="md:w-[480px] flex justify-between items-center">
          <img
            alt="About"
            className="w-full rounded-xl"
            src={`https://www.caspianrocksolutions.com/caspianrocksolutions/${settings.image}`}
          ></img>
        </div>
      </div>
    </div>
  );
};

export default About;
